import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { IconTypographyContainer } from 'reservations/base/components/IconTypography';
import { ListItem } from 'reservations/base/components/ListItem';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useInvitedGuests } from 'reservations/booking/providers/BookingProvider';
import {
  EvenSplitIconTypography,
  PrivatePaymentIconTypography
} from 'reservations/checklessPayments/components/SplitBillIconTypography';
import { SplitRequestedBadge } from 'reservations/guests/components/GuestStatusBadges';
import { useUpdateGuestsMutation } from 'reservations/guests/queries/useUpdateGuestsMutation';

export const ManageSplitBillModal = () => {
  const [hasChanged, setHasChanged] = useState(false);
  const {
    modalContext: { primaryButtonLabel }
  } = useModal();
  const { control, handleSubmit } = useFormContext();
  const guests = useInvitedGuests();
  const mutation = useUpdateGuestsMutation();

  return (
    <BaseDrawer
      header="Split the bill"
      subheader="You may select some or all of your guests to split the bill. By inviting them to split, you will send them a link to save their card with Checkless Payments."
      primaryButton={{
        label: primaryButtonLabel,
        disabled: !hasChanged,
        onClick: handleSubmit((data: Record<string, any>) =>
          mutation.mutate(data)
        )
      }}
      footer="Unselected guests will not see information regarding Checkless Payments or splitting the bill."
      requireAuth
    >
      <IconTypographyContainer>
        <EvenSplitIconTypography />
        <PrivatePaymentIconTypography />
      </IconTypographyContainer>
      <Box pt="24px">
        <Typography sx={{ fontWeight: 600 }}>
          Who should split the bill?
        </Typography>
        <ListItem
          primaryLabel="You"
          primaryLabelSxOverride={{ fontWeight: 600 }}
          startAdornment={
            <Checkbox sx={{ paddingRight: 0 }} disabled checked />
          }
        />
        {guests!.map(({ id, name, check_splitting_enabled }, idx) => (
          <ListItem
            key={id}
            primaryLabel={name}
            inlineContent={<SplitRequestedBadge />}
            primaryLabelSxOverride={{ fontWeight: 600 }}
            includeDivider={idx < guests!.length - 1}
            startAdornment={
              <Controller
                name={`guests.${idx}.inviteToSplit`}
                control={control}
                render={({ field }) => (
                  <Checkbox
                    sx={{ paddingRight: 0 }}
                    defaultChecked={check_splitting_enabled}
                    onChange={e => {
                      setHasChanged(true);
                      field.onChange(e.target.checked);
                    }}
                  />
                )}
              />
            }
          />
        ))}
      </Box>
    </BaseDrawer>
  );
};
